import { buildIntlProps, getCurrentLocale } from '@leagueplatform/locales';

/**
 * Resolve a translation key outside of React components (e.g. Masonry action
 * handlers, utility functions). Inside React, prefer `useIntl()` or
 * `<FormattedMessage>` instead.
 *
 * Supports simple `{name}` placeholder interpolation against `values`. Missing
 * placeholders are left untouched. For richer ICU features (plurals, select,
 * rich text), use `formatMessage` / `<FormattedMessage>` from `react-intl`.
 *
 * Returns the translated string for the current locale, falling back to the
 * key itself if no message is found.
 */
export const getTranslation = (
  key: string,
  values?: Record<string, string | number>,
): string => {
  const { messages } = buildIntlProps(getCurrentLocale());
  const message = (messages[key] as string) ?? key;

  if (!values) return message;

  return message.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in values ? String(values[name]) : match,
  );
};
